import useSWR, { SWRConfiguration } from 'swr';
import swrConfig from 'utils/swrConfig';

const fetcher = async (): Promise<ExtensionInfo[]> => {
    const extensions = (await shopify.app.extensions()) as ExtensionInfo[];

    return extensions;
};

export const useEmbeddedStatusSwr = (config?: Partial<SWRConfiguration>) => {
    const { data, isLoading, error, mutate, isValidating } = useSWR<ExtensionInfo[]>('embedded-status', fetcher, {
        ...swrConfig,
        ...config,
    });

    return { data, isLoading, error, mutate, isValidating };
};

export interface ExtensionInfo {
    activations: AppEmbedIntegration[];
    handle: string;
    type: string;
}

export interface AppEmbedIntegration {
    target?: string;
    handle?: string;
    themeId?: string;
    name?: string;
    status?: string;
    activations: ThemeAppExtensionActivation[];
}

export interface ThemeAppExtensionActivation {
    target: string;
    themeId: string;
}
